export const autocompleteInputId = "autocomplete-delivery-address";
